import { observable, action, makeAutoObservable  } from 'mobx'
import { TextElement } from './componentStore'
import { v4 as uuidv4 } from 'uuid'

class TextStore {
  
  constructor() {
    makeAutoObservable(this);
  }

  calculateElementSize(fontSize, fontWeight, content){
    const element = document.createElement('span')
    element.id = 'baseSize'
    element.style.visibility = 'hidden'
    element.style.position = 'absolute'
    element.style.fontSize = fontSize + 'px'
    element.style.fontWeight = fontWeight + 'px'
    element.textContent = content
    document.body.appendChild(element)
    const el = document.querySelector('#baseSize')
    const { width, height } = el.getBoundingClientRect()
    el.remove()
    return {
      width,
      height
    }
  }

  aladinRobotoGroup = uuidv4()

  basicElementSizes = {
    'heading': (() => {
      return this.calculateElementSize(32, 700, 'Text template')
    })(),
    'subheading': (() => {
      return this.calculateElementSize(26, 600, 'Text template')
    })(),
    'body': (() => {
      return this.calculateElementSize(16, 400, 'Text template')
    })()
  }

  basicElements = [
    new TextElement(
      'display-1', 
      'Heading',
      {
        x: 0,
        y: 0,
        color: '#000',
        display: false
      },
      32,
      0,
      0,
      {
        id: 'arial',
        value: 'arial'
      },
      [{
        color: '#F63767',
        deltaStart: 0,
        deltaEnd: 7
      }],
      700, 
      1, 
      0,
      this.basicElementSizes.heading.height,
      this.basicElementSizes.heading.width,
      this.basicElementSizes.heading.height,
      this.basicElementSizes.heading.width,
      this.basicElementSizes.heading.height,
      this.basicElementSizes.heading.width,
      this.basicElementSizes.heading.height,
      this.basicElementSizes.heading.width,
      0,
      0,
      1.4,
      '0',
      1,
      false,
      false,
      null,
      0,
      0,
      false,
      'left'
    ),
    new TextElement(
      'display-2', 
      'Subheading',
      {
        x: 0,
        y: 0,
        color: '#000',
        display: false
      },
      24,
      0,
      0,
      {
        id: 'arial',
        value: 'arial'
      },
      [{
        color: '#7a00ff',
        deltaStart: 0,
        deltaEnd: 10
      }],
      600,
      1, 
      0, 
      this.basicElementSizes.subheading.height,
      this.basicElementSizes.subheading.width,
      this.basicElementSizes.subheading.height,
      this.basicElementSizes.subheading.width,
      this.basicElementSizes.subheading.height,
      this.basicElementSizes.subheading.width,
      this.basicElementSizes.subheading.height,
      this.basicElementSizes.subheading.width,
      0,
      0,
      1.4,
      '0',
      1,
      false,
      false,
      null,
      0,
      0,
      false,
      'left'
    ),
    new TextElement(
      'display-3', 
      'Body',
      {
        x: 0,
        y: 0,
        color: '#000',
        display: false
      },
      16,
      0,
      0,
      {
        id: 'arial',
        value: 'arial'
      }, 
      [{
        color: '#222222',
        deltaStart: 0,
        deltaEnd: 3
      }],
      400,
      1, 
      0,      
      this.basicElementSizes.body.height,
      this.basicElementSizes.body.width,
      this.basicElementSizes.body.height,
      this.basicElementSizes.body.width,
      this.basicElementSizes.body.height,
      this.basicElementSizes.body.width,
      this.basicElementSizes.body.height,
      this.basicElementSizes.body.width,
      0,
      0,
      1.4,
      '0',
      1,
      false,
      false,
      null,
      0,
      0,
      false,
      'left'
    ),
  ]

  baseBody = new TextElement(
    'display-6', 
    'Roboto template',
    {
      x: 0,
      y: 0,
      color: '#000',
      display: false
    },
    16,
    0,
    0,
    {
      id: 'roboto',
      value: 'Roboto'
    }, 
    [{
      color: '#222222',
      deltaStart: 0,
      deltaEnd: 11
    }], 
    400,
    1,
    0, 
    this.basicElementSizes.body.height,
    this.basicElementSizes.body.width,
    this.basicElementSizes.body.height,
    this.basicElementSizes.body.width,
    this.basicElementSizes.body.height,
    this.basicElementSizes.body.width,
    this.basicElementSizes.body.height,
    this.basicElementSizes.body.width,
    0,
    0,
    1.4,
    '0',
    1,
    false,
    false,
    null,
    0,
    0,
    false,
    'left'
  )

  baseSubHeading = new TextElement(
    'display-7', 
    'Acme template',
    {
      x: 0,
      y: 0,
      color: '#000',
      display: false
    },
    24, 
    0, 
    0,
    {
      id: 'acme',
      value: 'Acme'
    },
    [{
      color: '#222222',
      deltaStart: 0,
      deltaEnd: 12
    }], 
    600,
    1,
    0, 
    this.basicElementSizes.subheading.height,
    this.basicElementSizes.subheading.width,
    this.basicElementSizes.subheading.height,
    this.basicElementSizes.subheading.width,
    this.basicElementSizes.subheading.height,
    this.basicElementSizes.subheading.width,
    this.basicElementSizes.subheading.height,
    this.basicElementSizes.subheading.width,
    0,
    0,
    1.4,
    '0',
    1,
    false,
    false,
    null,
    0,
    0,
    false,
    'left'
  )

  baseHeading = new TextElement(
    'display-8', 
    'Able template',
    {
      x: 0,
      y: 0,
      color: '#000',
      display: false
    }, 
    32,
    0,
    0,
    {
      id: 'abel',
      value: 'Abel'
    },
    [{
      color: '#222222',
      deltaStart: 0,
      deltaEnd: 12
    }], 
    700,
    1,
    0, 
    this.basicElementSizes.heading.height,
    this.basicElementSizes.heading.width,
    this.basicElementSizes.heading.height,
    this.basicElementSizes.heading.width,
    this.basicElementSizes.heading.height,
    this.basicElementSizes.heading.width,
    this.basicElementSizes.heading.height,
    this.basicElementSizes.heading.width,
    0,
    0,
    1.4,
    '0',
    1,
    false,
    false,
    null,
    0,
    0,
    false,
    'left'
  )

  robotoGroup = uuidv4()
  standardGroup = uuidv4()
  saleGroup = uuidv4()
  mosterratGroup = uuidv4()
  creativeGroup = uuidv4()
  dateGroup = uuidv4()
  
  textTemplates = [
    this.baseBody,
    this.baseSubHeading,
    this.baseHeading,
    new TextElement(
      'display-7', 
      `5 March 2021`,
      {
        x: 0,
        y: 0,
        color: '#000',
        display: false
      }, 
      18, 
      0, 
      0,
      {
        id: 'roboto',
        value: 'Roboto'
      },
      [{
        color: '#3E66EF',
        deltaStart: 0,
        deltaEnd: 12
      }], 
      700,
      1,
      0,
      250,
      this.basicElementSizes.heading.height * 1.5,
      this.basicElementSizes.heading.height * 1.5,
      250,
      this.basicElementSizes.heading.height * 1.5,
      250,
      this.basicElementSizes.heading.height * 1.5,
      250,
      0,
      0,
      1.4,
      '0',
      1,
      false,
      false,
      this.dateGroup,
      0,
      0,
      false,
      'center'
    ), 
    new TextElement(
      'display-7', 
      `10:00 - 11:00 (New York)`,
      {
        x: 0,
        y: 0,
        color: '#000',
        display: false
      }, 
      18,
      0,
      0,
      {
        id: 'roboto',
        value: 'Roboto'
      },
      [{
        color: '#EF3C64',
        deltaStart: 0,
        deltaEnd: 24
      }], 
      700,
      1,
      0,
      250,
      this.basicElementSizes.heading.height,
      this.basicElementSizes.heading.height,
      250,
      this.basicElementSizes.heading.height,
      250,
      this.basicElementSizes.heading.height,
      250,
      0,
      0,
      1.4,
      '0',
      1,
      false,
      false,
      this.dateGroup,
      0,
      0,
      false,
      'center'
    ), 
    new TextElement(
      'display-7', 
      `CREATIVE`,
      {
        x: 0,
        y: 0,
        color: '#000',
        display: false
      },
      20, 
      0, 
      0,
      {
        id: 'montserrat',
        value: 'Montserrat'
      },
      [{
        color: '#333333',
        deltaStart: 0,
        deltaEnd: 8
      }], 
      400,
      1,
      0,
      150,
      this.basicElementSizes.heading.height * 1.5,
      this.basicElementSizes.heading.height * 1.5,
      150,
      this.basicElementSizes.heading.height * 1.5,
      150,
      this.basicElementSizes.heading.height * 1.5,
      150,
      0,
      0,
      1.4,
      '0',
      1,
      false,
      false,
      this.creativeGroup,
      0,
      0,
      false,
      'left'
    ), 
    new TextElement(
      'display-7', 
      `MARKETING COMPANY`,
      {
        x: 0,
        y: 0,
        color: '#000',
        display: false
      }, 
      20, 
      0, 
      0,
      {
        id: 'montserrat',
        value: 'Montserrat'
      },
      [{
        color: '#BE9A0F',
        deltaStart: 0,
        deltaEnd: 17
      }], 
      900,
      1,
      0, 
      150,
      this.basicElementSizes.heading.height * 1.25,
      this.basicElementSizes.heading.height * 1.25,
      150,
      this.basicElementSizes.heading.height * 1.25,
      150,
      this.basicElementSizes.heading.height * 1.25,
      150,
      0,
      0,
      1.4,
      '0',
      1,
      false,
      false,
      this.creativeGroup,
      0,
      0,
      false,
      'left'
    ), 

    new TextElement(
      'display-7', 
      `lorem impsum dolor sit amet, con.. elit anean`,
      {
        x: 0,
        y: 0,
        color: '#000',
        display: false
      }, 
      14, 
      0, 
      0,
      {
        id: 'lato',
        value: 'Lato'
      },
      [{
        color: '#333333',
        deltaStart: 0,
        deltaEnd: 21
      }], 
      400,
      1,
      0,      
      150,
      this.basicElementSizes.heading.height,
      this.basicElementSizes.heading.height,
      150,
      this.basicElementSizes.heading.height,
      150,
      this.basicElementSizes.heading.height,
      150,
      0,
      0,
      1.4,
      '0',
      1,
      false,
      false,
      this.creativeGroup,
      0,
      0,
      false,
      'left'
    ), 

    new TextElement(
      'display-7', 
      `Don't miss out on our`,
      {
        x: 0,
        y: 0,
        color: '#000',
        display: false
      }, 
      14, 
      0, 
      0,
      {
        id: 'lato',
        value: 'Lato'
      },
      [{
        color: '#333333',
        deltaStart: 0,
        deltaEnd: 21
      }], 
      700,
      1,
      0,
      250,
      65,
      65,
      250,
      65,
      250,
      65,
      250,
      0,
      0,
      1.4,
      '0',
      1,
      false,
      false,
      this.saleGroup,
      0,
      0,
      false,
      'center'
    ),    
    new TextElement(
      'display-7', 
      `GRAND SALE`,
      {
        x: 0,
        y: 0,
        color: '#000',
        display: false
      }, 
      35, 
      0, 
      0,
      {
        id: 'old standard tt',
        value: 'Old Standard TT'
      },
      [{
        color: '#333333',
        deltaStart: 0,
        deltaEnd: 10
      }], 
      700,
      1,
      0,
      250,
      47,
      47,
      250,
      47,
      250,
      47,
      250,
      0,
      0,
      1.4,
      '0',
      1,
      false,
      false,
      this.saleGroup,
      0,
      0,
      false,
      'center',
      null,
      false,
      {
        marginTop: '10px',
        marginBottom: '5px'
      }
    ),
    new TextElement(
      'display-7',
      `Up to -80% off everything`,
      {
        x: 0,
        y: 0,
        color: '#000',
        display: false
      }, 
      14, 
      0, 
      0,
      {
        id: 'lato',
        value: 'Lato'
      },
      [{
        color: '#333333',
        deltaStart: 0,
        deltaEnd: 25
      }], 
      700,
      1,
      0, 
      29,
      250,
      29,
      250,
      29,
      250,
      29,
      250,
      0,
      0,
      1.4,
      '0',
      1,
      false,
      false,
      this.saleGroup,
      0,
      0,
      false,
      'center'
    ),
    new TextElement(
      'display-7', 
      'We are looking for:',
      {
        x: 0,
        y: 0,
        color: '#000',
        display: false
      }, 
      13, 
      0, 
      0,
      {
        id: 'montserrat',
        value: 'Montserrat'
      },
      [{
        color: '#97BA00',
        deltaStart: 0,
        deltaEnd: 19
      }], 
      700,
      1,
      0, 
      this.basicElementSizes.subheading.width,
      45,
      45,
      this.basicElementSizes.subheading.width,
      45,
      this.basicElementSizes.subheading.width,
      45,
      this.basicElementSizes.subheading.width,
      0,
      0,
      1.4,
      '0',
      1,
      false,
      false,
      this.mosterratGroup,
      0,
      0,
      false,
      'left'
    ),
    new TextElement(
      'display-7', 
      `|WEB-DESIGNERS \n|DEVELOPERS \n|PROGRAMMERS`,
      {
        x: 0,
        y: 0,
        color: '#000',
        display: false
      }, 
      13, 
      0, 
      0,
      {
        id: 'montserrat',
        value: 'Montserrat'
      },
      [{
        color: '#333333',
        deltaStart: 0,
        deltaEnd: 39
      }], 
      500,
      1,
      0, 
      this.basicElementSizes.subheading.width,
      this.basicElementSizes.subheading.height,
      this.basicElementSizes.subheading.height,
      this.basicElementSizes.subheading.width,
      this.basicElementSizes.subheading.height,
      this.basicElementSizes.subheading.width,
      this.basicElementSizes.subheading.height,
      this.basicElementSizes.subheading.width,
      0,
      0,
      1.4,
      '0',
      1,
      false,
      false,
      this.mosterratGroup,
      0,
      0,
      false,
      'left',
      null,
      false,
      {
        marginTop: '5px'
      }
    ),
    new TextElement(
      'display-7', 
      '"Who needs a boyfriend when you have the best set of friends."',
      {
        x: 0,
        y: 0,
        color: '#000',
        display: false
      }, 
      16, 
      0, 
      0,
      {
        id: 'old standard tt',
        value: 'Old Standard TT'
      },
      [{
        color: '#333333',
        deltaStart: 0,
        deltaEnd: 62
      }], 
      700,
      1,
      0, 
      200,
      this.basicElementSizes.subheading.height * 2,
      this.basicElementSizes.subheading.height * 2,
      200,
      this.basicElementSizes.subheading.height * 2,
      200,
      this.basicElementSizes.subheading.height * 2,
      200,
      0,
      0,
      1.4,
      '0',
      1,
      false,
      false,
      this.standardGroup,
      0,
      0,
      false,
      'left'
    ),
    new TextElement(
      'display-7', 
      'John Doe',
      {
        x: 0,
        y: 0,
        color: '#000',
        display: false
      }, 
      14, 
      0, 
      0,
      {
        id: 'league script',
        value: 'League Script'
      },
      [{
        color: '#333333',
        deltaStart: 0,
        deltaEnd: 8
      }], 
      400,
      1,
      0,
      200,
      this.basicElementSizes.subheading.height,
      this.basicElementSizes.subheading.height,
      200,
      this.basicElementSizes.subheading.height,
      200,
      this.basicElementSizes.subheading.height,
      200,
      0,
      0,
      1.4,
      '0',
      1,
      false,
      false,
      this.standardGroup,
      0,
      0,
      false,
      'center',
      null,
      false,
      {
        marginTop: '10px'
      }
    ),
    new TextElement(
      'display-7', 
      'life can only be understood backwards; but it must be lived forwards',
      {
        x: 0,
        y: 0,
        color: '#000',
        display: false
      }, 
      18, 
      0, 
      0,
      {
        id: 'roboto',
        value: 'Roboto'
      },
      [{
        color: '#52979F',
        deltaStart: 0,
        deltaEnd: 68
      }], 
      600,
      1,
      0,
      250,
      75,
      75,
      250,
      75,
      250,
      75,
      250,
      0,
      0,
      1.4,
      '0',
      1,
      false,
      false,
      this.robotoGroup,
      0,
      0,
      false,
      'left'
    ),
    new TextElement(
      'display-7', 
      '@instagram',      
      {
        x: 0,
        y: 0,
        color: '#000',
        display: false
      },  
      12, 
      0, 
      0,
      {
        id: 'roboto',
        value: 'Roboto'
      },
      [{
        color: '#52979F',
        deltaStart: 0,
        deltaEnd: 10
      }], 
      600,
      1,
      0, 
      250,
      this.basicElementSizes.subheading.height,
      this.basicElementSizes.subheading.height,
      250,
      this.basicElementSizes.subheading.height,
      250,
      this.basicElementSizes.subheading.height,
      250,
      0,
      0,
      1.4,
      '0',
      1,
      false,
      false,
      this.robotoGroup,
      0,
      0,
      false,
      'left',
      null,
      false,
      {
        marginTop: '10px'
      }
    ),
    new TextElement(
      'display-7', 
      'Alata template',      
      {
        x: 0,
        y: 0,
        color: '#000',
        display: false
      },  
      24, 
      0, 
      0,
      {
        id: 'alata',
        value: 'Alata'
      },
      [{
        color: '#3767f5',
        deltaStart: 0,
        deltaEnd: 12
      }], 
      600,
      1,
      0, 
      this.basicElementSizes.subheading.height,
      this.basicElementSizes.subheading.width,
      this.basicElementSizes.subheading.height,
      this.basicElementSizes.subheading.width,
      this.basicElementSizes.subheading.height,
      this.basicElementSizes.subheading.width,
      this.basicElementSizes.subheading.height,
      this.basicElementSizes.subheading.width,
      0,
      0,
      1.4,
      '0',
      1,
      false,
      false,
      null,
      0,
      0,
      false,
      'left'
    ),
    new TextElement(
      'display-7', 
      'Aladin template',      
      {
        x: 0,
        y: 0,
        color: '#000',
        display: false
      },   
      32, 
      0, 
      0,
      {
        id: 'aladin',
        value: 'Aladin'
      },
      [{
        color: '#222222',
        deltaStart: 0,
        deltaEnd: 15
      }], 
      600,
      1,
      0, 
      this.basicElementSizes.subheading.height,
      this.basicElementSizes.subheading.width,
      this.basicElementSizes.subheading.height,
      this.basicElementSizes.subheading.width,
      this.basicElementSizes.subheading.height,
      this.basicElementSizes.subheading.width,
      this.basicElementSizes.subheading.height,
      this.basicElementSizes.subheading.width,
      0,
      0,
      1.4,
      '0',
      1,
      false,
      false,
      null,
      0,
      0,
      false,
      'left'
    )
  ]

  getTextTemplates(){
    const textElems = []
    this.textTemplates.forEach(element => {
      if(element.groupId){
        const idx = textElems.findIndex(({ groupId: id }) => id === element.groupId)
        if(idx === -1){
          textElems.push({
            elements: [element],
            groupId: element.groupId
          })
        }
        if(idx > -1){
          textElems[idx].elements.push(element)
        }
      }
      if(!element.groupId){
        textElems.push(element)
      }
    })
    return textElems
  }

}

export default new TextStore